import clsx from "clsx";
import { ReactNode } from "react";

import { ProgressBar } from "@smart/itops-sb-design-system-dom";

type HeadingProps = {
  nav?: ReactNode;
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  loading?: boolean;
  className?: string;
  hidden?: boolean;
  isHeaderBackgroundBranded?: boolean;
  isHeaderUnderlineBranded?: boolean;
};

const Heading = ({
  nav,
  left,
  center,
  right,
  loading,
  className,
  hidden = false,
  isHeaderBackgroundBranded,
  isHeaderUnderlineBranded,
}: HeadingProps) => {
  if (hidden) {
    return null;
  }

  return (
    <div className={className}>
      {nav && (
        <div className="flex items-center px-8 py-[0.6rem] bg-white border-b border-neutral-100 z-1 min-h-[5rem]">
          {nav}
        </div>
      )}
      <div
        className={clsx(
          "flex items-center px-8 py-4 relative shadow-none border-b h-28 z-1",
          isHeaderUnderlineBranded
            ? "border-[var(--brand-color)]"
            : "border-neutral-200",
          isHeaderBackgroundBranded ? "bg-[var(--brand-color)]" : "bg-white",
        )}
        data-testid="heading-wrapper"
      >
        <div className="flex flex-[1_1] w-full @tablet:w-[30rem] justify-start">
          {left}
        </div>
        {center && <div className="flex flex-1 justify-center">{center}</div>}
        {right && (
          <div className="flex flex-[1_1] w-[30rem] justify-end">{right}</div>
        )}
        {loading && <ProgressBar overlay className="h-[0.3rem]" />}
      </div>
    </div>
  );
};

export { Heading, HeadingProps };
